import { useNavigation, useRoute } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useCallback } from 'react';
import { ScreenNamesEnum } from '@/constants';
import { ModalNamesEnum } from '@/constants/enums/modal.names.enum';

export function useAppRouter() {
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const route = useRoute();

  const goBack = useCallback(() => {
    // global.ignoreNextNavigation = true;
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(ScreenNamesEnum.MainScreen as any);
    }
  }, [navigation]);

  const navigateTo = useCallback(
    (screen: ScreenNamesEnum | ModalNamesEnum, params?: any, options?: { merge?: boolean; pop?: boolean }) => {
      setTimeout(() => {
        navigation.navigate(screen as any, params, options);
      }, 0);
    },
    [navigation],
  );

  const resetStackTo = useCallback(
    (screen: ScreenNamesEnum, params?: any) => {
      setTimeout(() => {
        // global.ignoreNextNavigation = true;
        navigation.reset({
          index: 0,
          routes: [{ name: screen, params }],
        });
      }, 0);
    },
    [navigation],
  );

  return {
    currentRoute: route.name,
    goBack,
    params: (route.params || {}) as any,
    navigateTo,
    resetStackTo,
    state: navigation.getState(),
  };
}
